<template>
  <div>
    <Tree
      :data="treeData"
      @on-select-change="selectData"
      :render="renderContent"
    ></Tree>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      treeData: [],
    };
  },

  created: function () {
    this.getListTree();
  },

  methods: {
    getListTree() {
      this.$api
        .post("/dictionary/gettree?id=" + this.currentData)
        .then((rsp) => {
          if (rsp != false) {
            this.treeData = rsp.data;
          }
        });
    },

    selectData: function (data) {
      this.$emit("selectTreeData", data);
    },

    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%",
          },
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline",
              },
              style: {
                marginRight: "8px",
              },
            }),
            h("span", data.title + "(" + data.code + ")"),
          ]),
          h("span", {
            style: {
              display: "inline-block",
              float: "right",
              marginRight: "32px",
            },
          }),
        ]
      );
    },
  },
};
</script>
<style scoped>
</style>